"use client";

import type { RegisteredComponent } from "@builder.io/sdk-react";
import dynamic from "next/dynamic";

import { withValidation } from "@/libs/builder/validators/validateBuilderComponentData";

import { HORECA_LOCATOR_BUILDER_COMPONENT_NAME } from "./HoReCaLocator.constants";

export const horecaLocatorInputs = [
  {
    name: "defaultLatitude",
    type: "number",
    required: true,
    defaultValue: 0,
  },
  {
    name: "defaultLongitude",
    type: "number",
    required: true,
    defaultValue: 0,
  },
  {
    name: "defaultZoom",
    type: "number",
    defaultValue: 15,
  },
  {
    name: "storesLimit",
    type: "number",
    defaultValue: 1000,
  },
] as const satisfies Inputs;

export const HoReCaLocatorComponent: RegisteredComponent = {
  name: HORECA_LOCATOR_BUILDER_COMPONENT_NAME,
  component: dynamic(
    async () =>
      withValidation(
        horecaLocatorInputs,
        (await import("./HoReCaLocator")).HoReCaLocator,
        HORECA_LOCATOR_BUILDER_COMPONENT_NAME
      ),
    { ssr: false }
  ),
  inputs: horecaLocatorInputs,
};
